module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    staticStyle: {
      "background-color": "#EBECF1"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "fuente box-title p-t-12"
  }, [_vm._v("PERSONAL DEL ÁREA: " + _vm._s(this.descripcionArea))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    attrs: {
      "id": "area"
    }
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "box-footer",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('button', {
    staticClass: "fuente btn btn-primary fs-13",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#modalNuevo"
    },
    on: {
      "click": function($event) {
        return _vm.limpiar()
      }
    }
  }, [_vm._v("Nuevo Registro\n                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "fuente col-xs-12 table-responsive"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "fuente fs-12 table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "tablaDetalle_info",
      "role": "grid",
      "id": "tablaDetalle"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.personas), function(item) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(item.cont))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.dni))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nombres) + " " + _vm._s(item.apePaterno) + " " + _vm._s(item.apeMaterno) + "\n                                                    ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cargo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.correo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.sigla))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(item.fecNacimiento)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nomUsuario))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.seteo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.defecto))]), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'usuarios',
          params: {
            idTrab: item.idTrabajador
          }
        }
      }
    }, [_c('span', {
      staticClass: "badge bg-yellow",
      on: {
        "click": function($event) {
          return _vm.enviar(item)
        }
      }
    }, [_vm._v("V")])])], 1), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [_c('span', {
      staticClass: "badge bg-red",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modalAnular"
      },
      on: {
        "click": function($event) {
          return _vm.verAnular(item)
        }
      }
    }, [_vm._v("X")])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "fuente col-md-12",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.error.desError) + "\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalNuevo",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(1), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.texto) + "\n                                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body fs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 m-b-10"
  }, [_vm._v("\n                                                        Flag Seteo:\n                                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuByArea.flagSeteo),
      expression: "usuByArea.flagSeteo"
    }],
    attrs: {
      "type": "checkbox",
      "true-value": "1",
      "false-value": "0"
    },
    domProps: {
      "checked": Array.isArray(_vm.usuByArea.flagSeteo) ? _vm._i(_vm.usuByArea.flagSeteo, null) > -1 : _vm._q(_vm.usuByArea.flagSeteo, "1")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.usuByArea.flagSeteo,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.usuByArea, "flagSeteo", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.usuByArea, "flagSeteo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.usuByArea, "flagSeteo", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("\n                                                        Flag Defecto:\n                                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuByArea.flagDefecto),
      expression: "usuByArea.flagDefecto"
    }],
    attrs: {
      "type": "checkbox",
      "true-value": "1",
      "false-value": "0"
    },
    domProps: {
      "checked": Array.isArray(_vm.usuByArea.flagDefecto) ? _vm._i(_vm.usuByArea.flagDefecto, null) > -1 : _vm._q(_vm.usuByArea.flagDefecto, "1")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.usuByArea.flagDefecto,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.usuByArea, "flagDefecto", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.usuByArea, "flagDefecto", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.usuByArea, "flagDefecto", $$c)
        }
      }
    }
  }), _c('br'), _c('br')])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "usuario-container"
  }, [_c('span', {
    staticClass: "usuario-label"
  }, [_vm._v("Personal:")]), _c('br'), _vm._v(" "), _c('v-select', {
    staticClass: "fuente form-control m-t-10 m-b-10 combobox-personalizado3",
    staticStyle: {
      "max-width": "550px",
      "padding": "0px",
      "border-style": "hidden"
    },
    attrs: {
      "options": _vm.filteredUsuarios,
      "filterable": true,
      "label": "nombreCompleto",
      "placeholder": "Seleccionar"
    },
    on: {
      "input": _vm.selectPersonal
    },
    scopedSlots: _vm._u([{
      key: "no-options",
      fn: function(ref) {
        var search = ref.search;

        return [_vm._v("\n                                                                Lo siento, no hay usuarios que coincidan con \"" + _vm._s(search) + "\".\n                                                            ")]
      }
    }]),
    model: {
      value: (_vm.selectedIdPersonal),
      callback: function($$v) {
        _vm.selectedIdPersonal = $$v
      },
      expression: "selectedIdPersonal"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "fuente col-xs-12 table-responsive"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "fuente fs-12 table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "tablaDetalle_info",
      "role": "grid",
      "id": "tablaUsers"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(item) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(item.cont))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nomUsuario))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "fuente btn btn-primary fs-12 enabled-button",
      attrs: {
        "type": "button",
        "data-dismiss": "modal"
      },
      on: {
        "click": function($event) {
          return _vm.mergeUsuByArea(item.idUsuario)
        }
      }
    }, [_vm._v(" AGREGAR\n                                                                            ")])])])
  }), 0)])]), _vm._v(" "), (this.users.length === 0) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-primary fs-12 disabled-button",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "disabled": this.usuByArea.idUsuario = '0',
      "title": 'Seleccione un usuario'
    },
    on: {
      "click": function($event) {
        return _vm.mergeUsuByArea(_vm.item.idUsuario)
      }
    }
  }, [_vm._v("AGREGAR\n                                                            ")])]) : _vm._e()])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalAnular",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body"
  }, [_vm._v("\n                                                Se anulará a " + _vm._s(_vm.usuByArea.nombres) + " " + _vm._s(_vm.usuByArea.apePaterno) + "\n                                                " + _vm._s(_vm.usuByArea.apeMaterno) + " de esta área. "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-danger fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.anularUsuByArea(_vm.usuByArea)
      }
    }
  }, [_vm._v("Anular\n                                                ")])])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc",
    attrs: {
      "aria-label": "ITEM",
      "aria-sort": "ascending",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                                        ITEM")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "DNI",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                                        DNI")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "NOMBRE",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                                        NOMBRE")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "CARGO",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("CARGO")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "CORREO",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("CORREO")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "SIGLA",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("SIGLA")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "FECHA NACIMIENTO",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                                        FECHA NACIMIENTO")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "USUARIO",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("USUARIO")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "USUARIO",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("SETEO")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "USUARIO",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("DEFECTO")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "DETALLE",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                                        DETALLE\n                                                    ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "ANULAR",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("ANULAR")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc",
    attrs: {
      "aria-label": "ITEM",
      "aria-sort": "ascending",
      "aria-controls": "tablaUsers",
      "tabindex": "0"
    }
  }, [_vm._v("ITEM")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "NOMBRE USUARIO",
      "aria-controls": "tablaUsers",
      "tabindex": "0"
    }
  }, [_vm._v("NOMBRE\n                                                                            USUARIO\n                                                                        ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "AGREGAR",
      "aria-controls": "tablaUsers",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                                                            AGREGAR\n                                                                        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("¿DESEAS\n                                                    ANULAR A\n                                                    ESTE USUARIO DEL ÁREA?")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17909649"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Area_Detalle.vue
// module id = 329
// module chunks = 1